import {LayoutBreakpointsConfig} from '../../components-shared/LayoutSizeProvider/types'

export const LAYOUT_BREAKPOINTS_START: LayoutBreakpointsConfig = {
  // mobile
  XS: 280,
  S: 600,
  // desktop & tablet
  M: 750,
  L: 1201,
}
